
import Vue from 'vue'
import CONF from '@/app.conf.json'
import {Util} from '../commons/util'

// Promise 垫片
require('core-js/fn/promise');


let Service = {
    
    /**
     * 查询订单列表
     *
     * @param {Object} plazaCode 查询参数
     *
     * @return Promise
     */
    queryOrderList(plazaCode) {
        
        let url = CONF.API.orderList;
    
        return new Promise((resolve, reject) => {
            Vue.http.jsonp(url, {
                params: {
                    plazaCode: plazaCode
                },
                timeout: 3000,
                jsonpCallback: 'call'
            }).then(data => {
                
                if (data.body.code === '0') {
                
                    resolve(data.body.data);
                } else if (data.body.code === '0005') {
    
                    resolve([]);
                }
            }, data => {
            
                reject(new Error(data));
            });
        });
    },
    /**
     * 预约商品
     * */
    
    createOrder(commoId, commoNo) {
        
        let url = CONF.API.createOrder;
    
        return new Promise((resolve, reject) => {
            Vue.http.jsonp(url, {
                params: {
                    commoId: commoId,
                    commoNo: commoNo
                },
                timeout: 3000,
                jsonpCallback: 'callback'
            }).then(data => {
    
                resolve(data.body);
                
            }, data => {
            
                reject(new Error(data));
            });
        });
        
    },
    
    /**
     * 商品详情
     */
    commonInfo(commonId) {
    
        let url = CONF.API.commonInfo;
    
        return new Promise((resolve, reject) => {
            Vue.http.jsonp(url, {
                params: {
                    commonId: commonId
                },
                //timeout: 3000,
                jsonpCallback: 'callback'
            }).then(data => {
            
                if (data.body.code === '0') {
                
                    resolve(data.body.data);
                } else if (data.body.code === '0005') {
                
                    resolve([]);
                }
            }, data => {
            
                reject(new Error(data));
            });
        });
    },
    /**
     * 推荐数据
     * @param commonId
     * @returns {Promise}
     */
    commonDetail(plazaCode) {
        
        let url = CONF.API.commonDetail;
        
        return new Promise((resolve, reject) => {
            Vue.http.jsonp(url, {
                params: {
                    plazaCode: plazaCode,
                    floor: '',
                    category: '',
                    pageNum: '1'
                },
                jsonpCallback: 'callback'
            }).then(data => {
                
                if (data.body.code === '0') {
                    
                    resolve(data.body.data);
                } else if (data.body.code === '0005') {
                    
                    resolve([]);
                }
            }, data => {
                
                reject(new Error(data));
            });
        });
    },
    /**
     * 商品详情（有规则）
     * @param goodsCode
     * @returns {Promise}
     */
    productRule(goodsCode){
        let url = CONF.API.productRule,
            jsonpCallback = 'goodsCallback';
        
        url = url
            .replace('{{goodsCode}}', goodsCode)
            .replace('{{callback}}', jsonpCallback);
        
        return new Promise((resolve, reject) => {
            Vue.http.jsonp(url,{
                jsonpCallback: jsonpCallback
            }).then(data => {
                if(data.body.code === '0' || data.body.code === '0005'){
                    resolve(data.body.data)
                }else {
                    reject(new Error(`${url}接口错误`));
                }
            }, data=>{
                reject(new Error(data))
            });
        });
    },
};
export default Service;



// WEBPACK FOOTER //
// ./src/services/Order.js